"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uuid_1 = require("uuid");

var AbstractMessage = function AbstractMessage(id) {
  _classCallCheck(this, AbstractMessage);

  this.id = id || "TM".concat(uuid_1.v4());
};

exports.AbstractMessage = AbstractMessage;